import React from 'react';
import Katex from 'parse-katex';
import '../../../public/static/bower_components/katex/dist/katex.min.css';

/*
 Parses all HTML code and renders all LaTeX code
 (by default marked by $ ... $ for inline equations, and $$ ... $$ for display mode)
 to properly formatted expressions using KaTeX.
 */

const MathMarkup = React.createClass({
    render() {
        var text = ([this.props.text].concat(this.props.children)).join(' ');
        var html = text ? {__html: Katex.renderLaTeX(text)} : null;
        return (
            <span dangerouslySetInnerHTML={html}></span>
        );
    }
});

export default MathMarkup;


/** WEBPACK FOOTER **
 ** ./src/components/MathMarkup/MathMarkup.js
 **/